module.exports = __webpack_public_path__ + "img/turkish-lira-sign.3514662b.svg";